import { createSelector } from 'reselect';

const gettingStarted = (store) => store.apps.gettingStarted;

const appStorageSelector = createSelector(
  [gettingStarted],
  (gettingStartedStore) => gettingStartedStore.appStorage,
);

export { appStorageSelector };
